import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  Input,
  Text,
  useTheme,
} from "@chakra-ui/react";
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { Theme } from "../../theme";
import { useNavigate } from "react-router-dom";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";

const ModifyIncentiveTarget = () => {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [isDataFetching, setIsDataFetching] = React.useState(true);

  const [incentiveDailyRidesTarget, setIncentiveDailyRidesTarget] =
    React.useState("");
  const [incentiveFastPickupTarget, setIncetiveFastpickupTarget] =
    React.useState("");
  const [incetiveFastpickupMinutes, setIncetiveFastpickupMinutes] =
    React.useState("");
  const [incentivePeakhoursTarget, setIncentivePeakHoursTarget] =
    React.useState("");

  const [createStatus, setCreateStatus] = React.useState("");

  const getIncentiveTargets = async () => {
    try {
      const res = await axios.get(`/incentives/targets`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("res ", res.data);
      setIncentiveDailyRidesTarget(res.data?.daily_rides_target);
      setIncetiveFastpickupTarget(res.data?.fast_pickup_daily_cap);
      setIncetiveFastpickupMinutes(res.data?.fast_pickup_minutes);
      setIncentivePeakHoursTarget(res.data?.peak_hour_rides_target);
    } catch (error) {
      console.log(error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const handleModifyTarget = async (e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    const data = {
      daily_rides_target: Number(incentiveDailyRidesTarget),
      fast_pickup_minutes: Number(incetiveFastpickupMinutes),
      fast_pickup_daily_cap: Number(incentiveFastPickupTarget),
      peak_hour_rides_target: Number(incentivePeakhoursTarget),
    };
    try {
      const res = await axios.put(`/incentives/targets`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setCreateStatus("created");
      console.log("submit", res);
      setTimeout(() => {
        navigate("/incentives");
      }, 2000);
    } catch (error) {
      console.log(error);
      setCreateStatus("error");
    }
  };

  React.useEffect(() => {
    getIncentiveTargets();
  }, []);

  return (
    <Box style={{ padding: "2rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading2,
          marginBottom: theme.space["3xl"],
        }}
      >
        Update Incentive Targets
      </Text>

      <Box
        style={{
          width: "50%",
          backgroundColor: "#FFFFFF",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <form onSubmit={handleModifyTarget}>
          <Flex flexDirection={"column"}>
            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Daily Rides Target
            </label>
            <Input
              type="number"
              value={incentiveDailyRidesTarget}
              onChange={(e) => setIncentiveDailyRidesTarget(e.target.value)}
              name="incentiveDailyRidesTarget"
              placeholder="incentiveDailyRidesTarget"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Fast Pickup Daily Target
            </label>
            <Input
              type="number"
              value={incentiveFastPickupTarget}
              onChange={(e) => setIncetiveFastpickupTarget(e.target.value)}
              name="incentiveFastPickupTarget"
              placeholder="incentiveFastPickupTarget"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Fast Pickup Minutes
            </label>
            <Input
              type="number"
              value={incetiveFastpickupMinutes}
              onChange={(e) => setIncetiveFastpickupMinutes(e.target.value)}
              name="incetiveFastpickupMinutes"
              placeholder="incetiveFastpickupMinutes"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Peak Hour Incentive Target
            </label>
            <Input
              type="number"
              value={incentivePeakhoursTarget}
              onChange={(e) => setIncentivePeakHoursTarget(e.target.value)}
              name="incentivePeakhoursTarget"
              placeholder="incentivePeakhoursTarget"
              variant={"outline"}
            />

            <Box sx={{ marginTop: theme.space.xxl }}>
              <Button
                type="submit"
                width="100%"
                height="3rem"
                rightIcon={<FaArrowRight />}
                isLoading={isDataFetching ? true : false}
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
              >
                <Text sx={{ fontSize: theme.fontSizes.body }}>Update</Text>
              </Button>
            </Box>

            <Box sx={{ minHeight: "3.25rem" }}>
              {createStatus === "created" && (
                <Alert status="success">
                  <AlertIcon />
                  Incentive target updated successfully.
                </Alert>
              )}
              {createStatus === "error" && (
                <Alert status="error" borderRadius={"4px"}>
                  <AlertIcon />
                  Opps! Something went wrong.
                </Alert>
              )}
            </Box>
          </Flex>
        </form>
      </Box>
    </Box>
  );
};

export default ModifyIncentiveTarget;
